import type { FormTourConfig } from './formTour';

const CREATE_JOB_FROM_URL_START_PATH = '/jobs';

export const createJobFromUrlTour = {
  taskId: 'creating_job_from_url',
  storageKey: 'onboarding-create-job-from-url-tour-step',
  startPath: CREATE_JOB_FROM_URL_START_PATH,
  overlineLabel: 'Create a Job from URL Tour',
  steps: [
    {
      title: 'Open the job form',
      description: 'Open the Add Job modal to start creating a job from a public posting URL.',
      targetTestIds: ['@jobs-add-new'],
    },
    {
      title: 'Paste the job URL',
      description: 'Paste a publicly accessible direct job posting URL here. LinkedIn /jobs/view/... links work best.',
      targetTestIds: ['@job-form-url'],
      disableBack: true,
    },
    {
      title: 'Extract the job details',
      description:
        'Click Create from URL to extract the job information into Harbor. This can take 1–2 minutes; the tour will continue when the form is ready.',
      targetTestIds: ['@job-form-create-from-url'],
    },
    {
      title: 'Select Job Status',
      description: 'Choose the pipeline status for this job from the Status field.',
      targetTestIds: ['@job-form-status', '@job-form-status-selected'],
      panelPlacement: 'above',
      interactionPaddingBelow: 280,
      disableBack: true,
    },
    {
      title: 'Select Client',
      description: 'Choose the client this job belongs to from the Client field.',
      targetTestIds: ['@job-form-client', '@job-form-client-selected'],
      panelPlacement: 'above',
      interactionPaddingBelow: 280,
    },
    {
      title: 'Save the job',
      description: 'Review the populated fields, then click Add to save the job.',
      targetTestIds: ['@job-form-submit'],
      completeWhenTargetClicked: ['@job-form-submit'],
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@job-form-url'],
    },
    1: { type: 'next' },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@job-form-submit'],
    },
    3: {
      type: 'wait-for-target',
      advanceTo: 4,
      waitForTargetTestIds: ['@job-form-status-selected'],
    },
    4: {
      type: 'wait-for-target',
      advanceTo: 5,
      waitForTargetTestIds: ['@job-form-client-selected'],
    },
    5: { type: 'complete' },
  },
} as const satisfies FormTourConfig;
